import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { TodoTableTodo } from "../TodoTable";

function getProjectColumn(): MRT_ColumnDef<TodoTableTodo> {
  return {
    header: "Projekt",
    accessorKey: "project",
    filterVariant: "multi-select"
  };
}

export { getProjectColumn };
